/* DurationRenderer.js */

"use strict";

const _ = require("lodash");
const moment = require("moment");
require("moment-duration-format");

class DurationRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("duration-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._model.on("Duration", (this._onDuration = this._onDuration.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("Duration");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */

    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setDuration(this._model.getValue());
            resolve();
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onDuration(newVal) {
        this._setDuration(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setDuration(newVal) {
        if (_.isNil(newVal)) {
            this._rootElem.innerHTML = "";
        } else {
            const format = `h[h] m[m] s[s]`;
            let duration = moment.duration(newVal, "milliseconds").format(format, {trim: false});
            this._rootElem.innerHTML = duration;
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = DurationRenderer;
